import "@arco-design/web-react/es/Upload/style";
import _Upload from "@arco-design/web-react/es/Upload";
import "@arco-design/web-react/es/Modal/style";
import _Modal from "@arco-design/web-react/es/Modal";
import React from 'react';
import { useUploadUrl } from './api';
import { ContentLoading } from '@/components';
import axios from 'axios';
export function CustomUpload({
  value,
  onChange,
  limit = 1,
  name = ''
}) {
  const {
    data,
    isLoading,
    isError,
    refetch
  } = useUploadUrl(name);

  if (isLoading) {
    return /*#__PURE__*/React.createElement(ContentLoading, null);
  }

  if (isError) {
    return null;
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_Upload, {
    name: "file",
    multiple: true,
    listType: "picture-card",
    fileList: value,
    limit: limit,
    onChange: (files, file) => {
      files = files.map(file => {
        if (file.status === 'done' && !file.url) {
          file.url = data.file_url;
        }

        return file;
      });
      onChange(files, file);
    },
    customRequest: async option => {
      const {
        file,
        onSuccess,
        onProgress,
        onError
      } = option;
      const controller = new AbortController();

      try {
        const res = await axios.put(data.upload_url, file, {
          headers: {
            'Content-Type': 'image/jpeg'
          },
          onUploadProgress: event => {
            let percent = 0;

            if (event.total > 0) {
              percent = event.loaded / event.total * 100;
            }

            onProgress(percent, event);
          },
          signal: controller.signal
        });
        onSuccess(res);
        await refetch();
      } catch (err) {
        onError(err);
      }

      return {
        abort() {
          controller.abort();
        }

      };
    },
    onPreview: file => {
      _Modal.info({
        title: '预览',
        content: /*#__PURE__*/React.createElement("div", {
          style: {
            textAlign: 'center'
          }
        }, /*#__PURE__*/React.createElement("img", {
          style: {
            maxWidth: '100%'
          },
          src: file.url,
          alt: ""
        }))
      });
    }
  }));
}